import store from '@/store'

var lang = (navigator.systemLanguage ? navigator.systemLanguage : navigator.language)
lang = lang.substr(0, 2)
if (localStorage.getItem('langSet')) {
  var language = localStorage.getItem('langSet')
} else {
  if (lang === 'zh') {
    language = 'zh-cn'
  } else {
    language = 'en'
  }
}
localStorage.setItem('language', language)
var x = new Date()
var timeZone = x.getTimezoneOffset() / 60
localStorage.setItem('timeZone', timeZone)
if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
  var system = 'ios'
} else if (/(Android)/i.test(navigator.userAgent)) {
  system = 'android'
} else if (/(mac)/i.test(navigator.userAgent)) {
  system = 'mac'
} else {
  system = 'win'
}
if (/(QtWebEngine)/i.test(navigator.userAgent.toLowerCase())) {
  var browser = 'qt'
} else if (/(MicroMessenger)/i.test(navigator.userAgent.toLowerCase())) {
  browser = 'wechat'
} else if (/(QQ)/i.test(navigator.userAgent.toLowerCase())) {
  browser = 'qq'
} else if (
  /(Firefox)/i.test(navigator.userAgent.toLowerCase()) ||
  (/(Safari)/i.test(navigator.userAgent.toLowerCase()) && !window.chrome) ||
  /(IE)/i.test(navigator.userAgent.toLowerCase()) ||
  /(Edge)/i.test(navigator.userAgent.toLowerCase())
) {
  browser = 'firefox'
} else {
  browser = 'chrome'
}
const config = {
  language: language,
  system: system,
  browser: browser,
  timezone: timeZone,
}
function formatDate (now) {
  var year = now.getFullYear()
  var month = now.getMonth() + 1
  var date = now.getDate()
  var hour = now.getHours()
  var minute = now.getMinutes()
  // var second = now.getSeconds()
  var dateSet = Number(localStorage.getItem('dateSet'))
  if (hour < 10) {
    var ihour = '0' + hour
  } else {
    ihour = hour
  }
  if (minute < 10) {
    var iminute = '0' + minute
  } else {
    iminute = minute
  }
  if (dateSet === 1) {
    return year + '-' + month + '-' + date + '  ' + ihour + ':' + iminute
  } else if (dateSet === 2) {
    return month + '-' + date + '-' + year + '  ' + ihour + ':' + iminute
  } else if (dateSet === 3) {
    return date + '-' + month + '-' + year + '  ' + ihour + ':' + iminute
  } else {
    return year + '-' + month + '-' + date + '  ' + ihour + ':' + iminute
  }
}
function parseDate (input, format) {
  format = format || 'yyyy-mm-dd' // default format
  var parts = input.match(/(\d+)/g)
  var i = 0
  var fmt = {}
  // extract date-part indexes from the format
  format.replace(/(yyyy|dd|mm)/g, function (part) { fmt[part] = i++ })
  return new Date(parts[fmt['yyyy']], parts[fmt['mm']] - 1, parts[fmt['dd']])
}
function timeSwitch (t) {
  // var d = new Date()
  // var gmtTime = d.getTimezoneOffset() * 60
  // var time = t + gmtTime
  var time = t
  var newDate = new Date(time * 1000)
  var Time = formatDate(newDate)
  return Time
}
function timeFormatSwitch (t) {
  if (t < 0) {
    t = 0
  }
  if (t === 0) {
    return '0s'
  } else if (!(t < 172800)) {
    return '> 48h'
  } else {
    var hour = ''
    var minute = ''
    var second = ''
    if (t >= 3600) {
      hour = Math.floor(t / 3600) + 'h'
    }
    if (t % 3600 >= 60) {
      minute = Math.floor(t % 3600 / 60) + 'm'
    }
    if (t % 60 === 0) {
      second = ''
    } else {
      second = t % 60 + 's'
    }
    return hour + minute + second
  }
}
function timeMoreSwitch (t) {
  var time = t
  var newDate = new Date(time * 1000)
  var year = newDate.getFullYear()
  var month = newDate.getMonth() + 1
  var date = newDate.getDate()
  var day = newDate.getDay()
  if (day === 0) {
    var monday = date - 6
  } else {
    monday = date - day + 1
  }
  var put = {
    year: year,
    month: month,
    date: date,
    day: monday
  }
  return put
}
function dayAfterSwitch (t, date) {
  var n = new Date()
  var d = (date + t)
  var day = Math.ceil((d - n.getTime() / 1000) / 60 / 60 / 24)
  return day
}
function trafficSwitch (bytes) {
  if (bytes === 0) {
    return '0 B'
  } else {
    var k = 1024
    var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    var q = Math.floor(Math.log(bytes) / Math.log(k))
    var size = (bytes / Math.pow(k, q)).toPrecision(4) + ' ' + sizes[q]
    if (!sizes[q]) {
      size = ''
    }
    return size
  }
}
function bandwidthSwitch (bw) {
  if (bw === 0) {
    return '0 B/s'
  } else {
    bw = bw / 8
    var k = 1000
    var sizes = ['B/s', 'KB/s', 'MB/s', 'GB/s', 'TB/s', 'PB/s', 'EB/s', 'ZB/s', 'YB/s']
    var q = Math.floor(Math.log(bw) / Math.log(k))
    if (q < 0) {
      var size = bw + ' ' + 'B/s'
    } else {
      size = (bw / Math.pow(k, q)).toPrecision(4) + ' ' + sizes[q]
    }
    return size
  }
}
function calculateBandwidthSwitch (bw) {
  if (bw === 0) {
    return '0 B/s'
  } else {
    var k = 1000
    var sizes = ['B/s', 'KB/s', 'MB/s', 'GB/s', 'TB/s', 'PB/s', 'EB/s', 'ZB/s', 'YB/s']
    var q = Math.floor(Math.log(bw) / Math.log(k))
    if (q < 0) {
      var size = bw + ' ' + 'B/s'
    } else {
      size = (bw / Math.pow(k, q)).toPrecision(4) + ' ' + sizes[q]
    }
    return size
  }
}
function bpsSwitch (bw) {
  if (bw === 0) {
    return '0bps'
  } else {
    var k = 1000
    var sizes = ['bps', 'kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps']
    var q = Math.floor(Math.log(bw) / Math.log(k))
    var size = (bw / Math.pow(k, q)).toPrecision(4) + ' ' + sizes[q]
    return size
  }
}
function bps (bw) {
  if (bw === 0) {
    var value = {
      value: 0,
      unit: 0
    }
  } else {
    var k = 1000
    // var sizes = ['bps', 'kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps']
    var q = Math.floor(Math.log(bw) / Math.log(k))
    if (q > 3) {
      q = 3
    }
    var size = (bw / Math.pow(k, q))
    value = {
      value: size,
      unit: q
    }
  }
  return value
}
function fileFalse (a, callback) {
  var x = []
  for (var i = 0; i < a.length; i++) {
    if (a[i].lastModifiedDate) {
      var lastModifiedTime = (a[i].lastModifiedDate).getTime()
    } else {
      lastModifiedTime = a[i].lastModified
    }
    x.push({
      fileName: a[i].name,
      lastModifiedTime: lastModifiedTime
      // lastModifiedTime: (a[i].lastModifiedDate).getTime()
    })
  }
  var back = x
  callback(back)
}
// function fileFalse (a) {
//   return new Promise((resolve, reject) => {
//     var x = []
//     for (var i = 0; i < a.length; i++) {
//       fileReader(a[i], a.length, function (response, length, value) {
//         response.onload = function () {
//           i = Math.random()
//           x.push('"fileName_' + i + '":"' + value + '"')
//           if (x.length === length) {
//             resolve(x)
//           }
//         }
//         response.onerror = function () {
//           i = Math.random()
//           x.push('"folderName_' + i + '":"' + value + '"')
//           if (x.length === length) {
//             resolve(x)
//           }
//         }
//       })
//     }
//   })
// }
// function fileReader (file, i, callback) {
//   var reader = new FileReader()
//   reader.readAsText(file)
//   var value = file.name
//   var length = i
//   callback(reader, length, value)
// }
function objectSwitch (array) {
  var string = array.join(',')
  string = `{` + string + `}`
  var object = JSON.parse(string)
  return object
}
function moreContent () {
  store.dispatch('addScroll', window.scrollY)
}
function windowSize () {
  var height = document.documentElement.clientHeight
  var width = document.documentElement.clientWidth
  var size = {
    height: height,
    width: width
  }
  store.dispatch('addSize', size)
}
function arrayHas (arr, obj) {
  var i = arr.length
  while (i--) {
    if (arr[i] === obj) {
      return true
    }
  }
  return false
}
function conditionCode (ip) {
  var gpu = function () {
    var canvas = document.createElement('canvas')
    var gl = canvas.getContext('experimental-webgl')
    var info = gl.getExtension('WEBGL_debug_renderer_info')
    var version = gl.getParameter(info.UNMASKED_RENDERER_WEBGL)
    return version
  }
  var screenSize = function () {
    var size = Math.max(screen.width, screen.height) * (window.devicePixelRatio || 1)
    return size
  }
  var ascii = function (str) {
    var strArry = str.split('')
    var strAscii = ''
    for (var i = 0; i < strArry.length; i++) {
      strAscii = strAscii + strArry[i].charCodeAt(0)
    }
    return strAscii
  }
  var code = ascii(gpu() + screenSize() + ip)
  return code
}
function arrayToInt (str) {
  var array = str.split('.')
  var num = 0
  for (var i = 0; i < array.length; i++) {
    var n = array.length - i - 1
    num = parseInt(array[i]) * Math.pow(10, n) + num
  }
  return num
}

function GetOs () {
  let sUserAgent = navigator.userAgent.toLocaleLowerCase()
  console.log(sUserAgent)
  console.log(navigator.platform)
  let isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows')
  let isMac = (navigator.platform === 'Mac68k') || (navigator.platform === 'MacPpc') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel')
  if (isMac) return 'MacOS'
  let isUnix = (navigator.platform === 'X11') && !isWin && !isMac
  if (isUnix) return 'Unix'
  let isLinux = (String(navigator.platform).indexOf('Linux') > -1)
  if (isLinux) return 'Linux'
  if (isWin) return 'Windows'
  return 'others'
}

function getOsDetail () {
  let sUserAgent = navigator.userAgent.toLocaleLowerCase()
  // console.log(sUserAgent)
  let isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows')
  let isMac = (navigator.platform === 'Mac68k') || (navigator.platform === 'MacPpc') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel')
  var start = sUserAgent.indexOf('(') + 1
  var end = sUserAgent.indexOf(')')
  if (isMac) {
    var MacOS = sUserAgent.slice(start, end)
    return MacOS
  }
  let isUnix = (navigator.platform === 'X11') && !isWin && !isMac
  if (isUnix) return 'Unix'
  let isLinux = (String(navigator.platform).indexOf('Linux') > -1)
  if (isLinux) return 'Linux'
  if (isWin) {
    var WinOs = sUserAgent.slice(start, end)
    return WinOs
  }
  return 'others'
}

export {
  config,
  GetOs,
  getOsDetail
}
export default
{
  config,
  timeSwitch,
  timeMoreSwitch,
  timeFormatSwitch,
  dayAfterSwitch,
  trafficSwitch,
  bandwidthSwitch,
  parseDate,
  fileFalse,
  objectSwitch,
  moreContent,
  bpsSwitch,
  bps,
  windowSize,
  arrayHas,
  conditionCode,
  arrayToInt,
  calculateBandwidthSwitch,
}
